import Vue from 'vue';
import Router from 'vue-router';
import Index from './pages/Index.vue';
import MissionStatement from './pages/MissionStatement.vue'
import PrivacyPolicy from './pages/PrivacyPolicy.vue';
import PrivacyPolicyEU from './pages/PrivacyPolicyEU.vue';
import TermsOfService from './pages/TermsOfService.vue';
import Products from './pages/Products.vue';
import Careers from './pages/Careers.vue';
import GraphicsProgrammer from './pages/careers/GraphicsProgrammer.vue';
import FXArtist from './pages/careers/FXArtist.vue';
import SeniorProgrammer from './pages/careers/SeniorProgrammer.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';

Vue.use(Router);

export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'index',
      components: { default: Index, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/mission-statement',
      name: 'missionstatement',
      components: { default: MissionStatement, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacypolicy',
      components: { default: PrivacyPolicy, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/privacy-policy-eu',
      name: 'privacypolicyeu',
      components: { default: PrivacyPolicyEU, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/terms-of-service',
      name: 'terms',
      components: { default: TermsOfService, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/products',
      name: 'products',
      components: { default: Products, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/careers',
      name: 'careers',
      components: { default: Careers, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/careers/graphics-programmer',
      name: 'graphicprogrammer',
      components: { default: GraphicsProgrammer, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
